//Give each tab an id so we can tell them apart and make sure we dont dispatch the action again on the tab that it originated in

const source = Math.floor(Math.random() * 10000);

export default source;
